<template>
    <v-row>
        <v-col sm="12">
            <v-card>
                <v-card-title>
                    <v-btn
                        small
                        @click="$router.go(-1)"
                        class="mr-4 btn-back"
                    >
                        <v-icon> mdi-arrow-left</v-icon>
                        Voltar
                    </v-btn>
                    <v-icon left>mdi-account-cash</v-icon>
                    Dados do Resgate
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row class="text-center">
                        <v-col cols="12" md="3" sm="6" xs="12">
                            <v-card
                                style="border: solid 1px #3A33E8; border-left: solid 10px #3A33E8;">
                                <v-card-title primary-title class="justify-center">
                                    {{ financial.requestDate | formatDate3 }}
                                </v-card-title>
                                <v-card-text>
                                    Data de Solicitação
                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" md="3" sm="6" xs="12">
                            <v-card
                                style="border: solid 1px #008000; border-left: solid 10px #008000;"
                            >
                                <v-card-title primary-title class="justify-center">
                                    {{ financial.valueReleased | money }}
                                </v-card-title>
                                <v-card-text> Saldo Liberado</v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" md="3" sm="6" xs="12">
                            <v-card class="mb-2 text-center"
                                    style="border: solid 1px #008000; border-left: solid 10px #008000;">
                                <v-card-title primary-title class="justify-center">
                                    {{ financial.valueAnticipation | money }}
                                </v-card-title>
                                <v-card-text> Saldo Antecipado</v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" md="3" sm="6" xs="12">
                            <v-card class="mb-2 text-center"
                                    style="border: solid 1px #3D1159; border-left: solid 10px #3D1159;">
                                <v-card-title primary-title class="justify-center">
                                    {{ financial.totalValue | money }}
                                </v-card-title>
                                <v-card-text> Valor Total</v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" md="3" sm="6" xs="12" v-show="financial.bankAccount">
                            <div class="mb-2">
                                <v-card
                                    style="border: solid 1px #3A33E8; border-left: solid 10px #3A33E8;">
                                    <v-card-title primary-title class="justify-center">
                                        Dados Bancários
                                    </v-card-title>
                                    <v-card-text>
                                        <p class="my-1"><strong> Banco: </strong> {{ financial.bank }}</p>
                                        <p class="my-1"><strong> Agência:</strong> {{ financial.agency }}</p>
                                        <p class="my-1"><strong> Conta:</strong> {{ financial.bankAccount }}</p>
                                    </v-card-text>
                                </v-card>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3" sm="6" xs="12" v-show="financial.chavePIX">
                            <div class="mb-2">
                                <v-card
                                    style="border: solid 1px #3A33E8; border-left: solid 10px #3A33E8;">
                                    <v-card-title primary-title class="justify-center">
                                        Dados Bancários
                                    </v-card-title>

                                    <v-card-text>
                                        <strong>Chave PIX:</strong> {{ financial.chavePIX }}
                                    </v-card-text>

                                </v-card>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3" sm="6" xs="12">
                            <v-card class="mb-2 text-center"
                                    style="border: solid 1px #008000; border-left: solid 10px #008000;">
                                <v-card-title primary-title class="justify-center">
                                    <span v-if="financial.paid"> Pago</span> <span v-else> Solicitado</span>
                                </v-card-title>
                                <v-card-text> Status</v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" md="3" sm="6" xs="12" v-show="financial.payDate">
                            <v-card class="mb-2 text-center"
                                    style="border: solid 1px #008000; border-left: solid 10px #008000;">
                                <v-card-title primary-title class="justify-center">
                                    {{ financial.payDate | formatDate3 }}
                                </v-card-title>
                                <v-card-text> Data de Pagamento</v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" md="3" sm="6" xs="12" class="fill-height" v-show="financial.payDate">
                            <v-card class="mb-2 text-center fill-height"
                                    style="border: solid 1px #3D1159; border-left: solid 10px #3D1159;">
                                <v-card-title class="justify-center text-center">
                                    <v-btn
                                        outlined
                                        v-show="financial.id"
                                        class="mx-1 btn-secondary"
                                        @click="downloadTicket()">
                                        <v-icon left>mdi-download</v-icon>
                                        Download
                                    </v-btn>
                                </v-card-title>
                                <v-card-text class="fill-height" style="height: 100%">
                                    Download do Comprovante
                                </v-card-text>
                            </v-card>
                        </v-col>


                    </v-row>

                </v-card-text>
                <v-alert type="warning" outlined v-show="!financial.id">Nenhum encontrado</v-alert>

            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
import {mask} from "vue-the-mask";

import {FINANCE_GET_ID} from "@/store/actions/financial.type";
import {FINANCIAL_ID_RESET_STATE} from "@/store/mutations/financial.type";
import {CHANGE_PROGRESS} from "@/store/mutations/mutations.type";
import {FinancialService} from "@/common/api/financial.service";

export default {
    name: "finance",
    directives: {mask},
    props: {
        id: {
            default: 0,
            type: Number,
            required: true
        }
    },

    components: {},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.commit(FINANCIAL_ID_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        Promise.all([
            await store.commit(FINANCIAL_ID_RESET_STATE),
            await store.dispatch(FINANCE_GET_ID, to.params.id)
        ]).then(() => {
            next();
        });
    },
    data: () => ({
        //Lista de Usuários
        pagination: {
            sortBy: "name"
        },
        search: "",
        selected: [],
        formIsValid: false,

        dialogActiveInactive: false,
        dialogDeleteService: false
    }),
    methods: {
        pushRouteToView(route) {
            this.$router.push({name: route});
        },
        //Methods Lista Usuarios
        toggleAll() {
            if (this.selected.length) this.selected = [];
            else this.selected = this.dados.slice();
        },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },
        downloadTicket() {
            this.$store.commit(CHANGE_PROGRESS, true)
            FinancialService.getIDFile(this.financial.id).then((response) => {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Lyndus_Comprovante_Resgate.pdf`); //or any other extension
                document.body.appendChild(link);
                link.click();

                this.$store.commit(CHANGE_PROGRESS, false)
            })
                .catch((err) => {
                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.text = `Não foi possível alterar status - ${err.status}`;
                    this.snackbar.color = "error";
                });
        },
        // deleteService(status){
        //     this.dialogDeleteService=false
        //     if(!status){
        //         return
        //     }
        //     this.$store.commit(CHANGE_PROGRESS, true)
        //     this.$store
        //         .dispatch(SERVICE_DELETE)
        //         .then(() => {
        //
        //             this.$store.commit(CHANGE_PROGRESS, false)
        //             this.snackbar.snackbar = true;
        //             this.snackbar.color = "success";
        //             this.snackbar.text = "Excluído com sucesso";
        //
        //             this.$router.push({
        //                 name: "services",
        //             });
        //         })
        //         .catch(({response}) => {
        //             this.$store.commit(CHANGE_PROGRESS, false)
        //             this.snackbar.snackbar = true;
        //             this.snackbar.color = "error";
        //             this.snackbar.text = "Erro ao excluir.";
        //             // console.log(response.data);
        //             if (typeof response.data.message !== "undefined") {
        //                 this.snackbar.text = response.data.message;
        //             }
        //         });
        // },
        // inactiveActive(status) {
        //     this.dialogActiveInactive=false
        //     if(!status){
        //         return
        //     }
        //     let action = this.service.active ? SERVICE_INACTIVE : SERVICE_ACTIVE;
        //     this.$store.commit(CHANGE_PROGRESS, true)
        //
        //     this.$store
        //         .dispatch(action, this.service.id)
        //         .then(() => {
        //            
        //             this.$store.commit(CHANGE_PROGRESS, false)
        //             this.snackbar.snackbar = true;
        //             this.snackbar.color = "success";
        //             this.snackbar.text = "Alterado com sucesso";
        //             this.$store.commit(SET_SERVICE_ACTIVE, !this.service.active)
        //         })
        //         .catch(({response}) => {
        //             this.$store.commit(CHANGE_PROGRESS, false)
        //             this.snackbar.snackbar = true;
        //             this.snackbar.color = "error";
        //             this.snackbar.text = "Erro ao alterar.";
        //             // console.log(response.data);
        //             if (typeof response.data.message !== "undefined") {
        //                 this.snackbar.text = response.data.message;
        //             }
        //         });
        // }
    },
    mounted() {
    },
    computed: {
        ...mapGetters(["snackbar", "inProgress", "checkUsers", "financial"])
    },
    watch: {}
};
</script>
